// ** Component Imports
import WalletsOverviewTabHeader from './components/WalletsOverviewTabHeader';

function WalletsOverviewTab() {
  return (
    <div>
      <WalletsOverviewTabHeader />
      {/* <WalletsOverviewTabContent /> */}
    </div>
  )
}

export default WalletsOverviewTab
